module.exports = __webpack_public_path__ + "media/QuatationsEmptyDark.99935c03.svg";